export class UserProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  image: string;
  companies: string[];
  roles: string[];
  emailConfirmed: boolean;
}
